export default __webpack_public_path__ + "static/media/loaderBlue.b0b4b921.gif";